import { AthleteEnergyExpenditureHistoryQuery } from "../../../../types";

type Edges = AthleteEnergyExpenditureHistoryQuery["athleteEnergyExpenditureHistory"]["edges"];

function avg(values: number[]): number | null {
  return values.length > 0 ? values.reduce((s, v) => s + v, 0) / values.length : null;
}

export const calculateHistoricalAverages = (groupedData: Map<string, Edges>) => {
  const daily = {
    tdee: [] as number[],
    activeEnergy: [] as number[],
    restingEnergy: [] as number[],
    targetIntake: [] as number[],
    loggedIntake: [] as number[],
    energyBalance: [] as number[],
  };

  groupedData.forEach((entries) => {
    // For wearable metrics, average across sources on a day, excluding nulls and zeros (no-data sentinel)
    const dayAvg = (vals: (number | null | undefined)[]): number | null =>
      avg(vals.filter((v): v is number => v != null && v !== 0));

    const push = (arr: number[], val: number | null) => {
      if (val != null) arr.push(val);
    };

    push(daily.tdee, dayAvg(entries.map(e => e.tdee)));
    push(daily.activeEnergy, dayAvg(entries.map(e => e.activeEnergy)));
    push(daily.restingEnergy, dayAvg(entries.map(e => e.restingEnergy)));

    // These fields are shared across sources on a day — take from first entry
    const first = entries[0];
    if (first?.targetDailyIntake != null && first.targetDailyIntake !== 0)
      daily.targetIntake.push(first.targetDailyIntake);
    if (first?.loggedIntake != null && first.loggedIntake !== 0)
      daily.loggedIntake.push(first.loggedIntake);
    if (first?.energyBalance != null && first.energyBalance !== 0)
      daily.energyBalance.push(first.energyBalance);
  });

  return {
    avgTdee: avg(daily.tdee),
    avgActiveEnergy: avg(daily.activeEnergy),
    avgRestingEnergy: avg(daily.restingEnergy),
    avgTargetIntake: avg(daily.targetIntake),
    avgLoggedIntake: avg(daily.loggedIntake),
    avgEnergyBalance: avg(daily.energyBalance),
  };
};
